import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../../data/hooks/auth'
import { useAuthForms } from '../custom-dialogs/auth'
import { up } from 'styled-breakpoints'
import Dropdown from '../dropdown'
import { useHistory } from 'react-router-dom'
import { DialogLevel, useDialog } from '../dialog/hook'
import GoodreadsImportDialog from '../custom-dialogs/goodreads-import'
import OnboardingDialog, { useOnboarding } from '../custom-dialogs/onboarding'

type ProfilePictureDropdownProps = {
  // Add your prop types here
}

const ProfilePictureDropdown: React.FunctionComponent<ProfilePictureDropdownProps> = () => {
    const history = useHistory()
    const { t } = useTranslation("common")

    const { user, setAuth } = useAuth()
    const { showLoginForm } = useAuthForms()
    const { setComponent } = useDialog()
    const openOnboarding = useOnboarding(DialogLevel.Default)

    const [isDropdownOpen, setDropDownOpen] = useState(false)

    if (!user) {
        return (
            <Container>
                <SignIn onClick={showLoginForm}>{t("header.login")}</SignIn>
            </Container>
        )
    }

    const items = [
        { title: t("header.profile"), action: () => history.push(`/profile/${user.public_id}`)},
        { title: "Goodreads import", action: () => setComponent(<GoodreadsImportDialog />)},
        { title: t("header.logout"), action: () => setAuth(null, null)},
    ]

    if (user?.id === 13980) {
        items.push({ title: "Onboarding", action: openOnboarding},)
    }

    return (
        <Container>
            <Dropdown
                isOpen={isDropdownOpen}
                items={items}
                setClosed={() => setDropDownOpen(false)}
            >
                <Profile src={user.picture || require('./images/default.svg')} onClick={() => setDropDownOpen(!isDropdownOpen)}/>
            </Dropdown>
        </Container>
    )
}

const Container = styled.div`
    display: none;

    ${up('desktop')} {
        display: grid;
        align-items: center;
        justify-items: center;
        
        margin-left: 25px;
    }
`

const Profile = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 50%;

    cursor: pointer;
`

const SignIn = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;

    color: ${p => p.theme.colors.accent};
    cursor: pointer;
`

export default ProfilePictureDropdown